import { USER_NAME_LS_KEY } from '../config/constants';

/** Best display name for who noted/handled an item. */
export const authorName = user =>
  user?.displayName || user?.email || (typeof localStorage !== 'undefined' && localStorage.getItem(USER_NAME_LS_KEY)) || 'Staff';
